import { render, staticRenderFns } from "./IntroQuestionScreen.vue?vue&type=template&id=28df456c&"
import script from "./IntroQuestionScreen.vue?vue&type=script&lang=js&"
export * from "./IntroQuestionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports